/* eslint-disable no-unused-vars */
/* eslint-disable  react/display-name */
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import PCard from "../../../components/pos/PCard.jsx";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";

import PConfirm from "../../../components/pos/PConfirm";
import PDatePicker from "../../../components/pos/PDatePicker";
import { AgentUtils } from "../../../utils/AgentUtils.js";

export default function YearEnding(props) {
  const { t } = useTranslation();
  const translate = t;
  const [financialYear, setFinancialYear] = useState({});
  const [nextFinancialYear, setNextFinancialYear] = useState({});
  const [blockYearEnding, setBlockYearEnding] = useState(false);
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [currFinancialYearStartDate, setCurrFinancialYearStartDate] =
    useState("");
  const [currFinancialYearEndDate, setCurrFinancialYearEndDate] = useState("");
  const [nextFinancialYearStartDate, setNextFinancialYearStartDate] =
    useState("");
  const [nextFinancialYearEndDate, setNextFinancialYearEndDate] = useState("");

  const [bookEntryStartDate, setBookEntryStartDate] = useState("");
  const [showCloseAccount, setShowCloseAccount] = useState(false);

  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState(0);
  const isMounted = React.useRef(true);
  const [strProgress, setStrProgress] = useState(0);

  useEffect(() => {
    loadData();
    return () => {
      isMounted.current = false;
    };
  }, []);

  var biRef = {};

  async function loadData() {
    await getActiveFinancialYear();
    await checkForActiveJob();
  }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function checkForActiveJob() {
    let { data } = await API.get("/api/v1/activeworkrequestByType/year_end");
    if (data.length > 0) {
      setLoading(true);
      monitor(data[0].id);
    }
  }

  async function monitor(id) {
    while (true) {
      console.log("isMounted.current", isMounted.current);
      if (!isMounted.current) {
        break;
      }
      try {
        let result = await API.get("/api/v1/workrequest/" + id);
        setProgress("( " + result.data.progress + " %)");
        setStrProgress(result.data.strProgress);

        if (result.data.status === "Failed") {
          props.setAlert({
            show: true,
            title: translate("Alert!"),
            message: translate("Reconcilation Failed, please contact support"),
          });
          break;
        } else if (result.data.status === "Completed") {
          props.setAlert({
            show: true,
            title: translate("Success!"),
            message: translate("Year End process completed successfully"),
          });
          await getActiveFinancialYear();
          break;
        }
      } catch (err) {}
      await sleep(5000);
    }
    console.log("setLoading fasle");
    setLoading(false);
  }

  function showDetailedError(err) {}

  async function onYesNoClicked(context, value) {
    setLoading(true);
    try {
      let refresh_result = await API.get("/auth/v1/users/refresh");

      console.log("REFRESH response", refresh_result.data);

      let { data } = await API.post("/api/v1/workrequest", {
        actionType: "year_end",
        payload: JSON.stringify({
          bookEntryStartDate: bookEntryStartDate.toISOString(),
          currentFinancialYear: financialYear.id,
          newFinancialYear: nextFinancialYear.id,
          token: refresh_result.data.refreshToken,
          baseUrl: await AgentUtils.getBaseUrl(),
        }),
      });

      monitor(data.id);
    } catch (err) {
      setLoading(false);
      props.setAlert({
        show: true,
        title: translate("Alert!"),
        message: translate("Something went wrong!"),
      });
      console.log(err);
    }
  }

  async function getActiveFinancialYear() {
    let { data } = await API.get("/api/v1/currentfinancialyear");
    let nextData = await API.get("/api/v1/nextfinancialyear");

    populateData(data, nextData.data);
    console.log("Data fetched: " + JSON.stringify(data));
  }

  function populateData(curFinancialYear, nextFinancialYear) {
    setFinancialYear(curFinancialYear);
    setNextFinancialYear(nextFinancialYear);
    //let endDate = new Date();
    //endDate.setHours(0, 0, 0, 0);
    //data["bookEntryEndDate"] = endDate.toISOString();
    //setFinancialYear(data);
    setCurrFinancialYearStartDate(
      new Date(curFinancialYear.financialYearStartDate).toLocaleDateString()
    );
    setCurrFinancialYearEndDate(
      new Date(curFinancialYear.financialYearEndDate).toLocaleDateString()
    );
    setNextFinancialYearStartDate(
      new Date(nextFinancialYear.financialYearStartDate).toLocaleDateString()
    );
    setNextFinancialYearEndDate(
      new Date(nextFinancialYear.financialYearEndDate).toLocaleDateString()
    );
    setBookEntryStartDate(new Date(nextFinancialYear.financialYearStartDate));

    //if (
    //  new Date().getTime() >=
    //  new Date(curFinancialYear.financialYearEndDate).getTime()
    //) {
    setShowCloseAccount(true);
    //}
  }

  async function onSave() {
    if (validate()) {
      setConfirmContext({
        title: translate("Are You Sure"),
        message: translate(
          "Are you sure to close all accounts,This action can't be reverted!"
        ),
        type: "warning",
        open: true,
        yes: true,
        no: true,
      });
      setConfirmOpen(true);
    }
  }

  function validate() {
    if (
      new Date(bookEntryStartDate).getTime() <
      new Date(nextFinancialYear.financialYearStartDate).getTime()
    ) {
      console.log(
        new Date(bookEntryStartDate),
        new Date(nextFinancialYear.financialYearStartDate)
      );
      props.showMessage(
        "warning",
        translate(
          "Book entry date must be greater than or equal new financial year's start date"
        )
      );
      return false;
    }
    if (
      new Date(bookEntryStartDate).getTime() >=
      new Date(nextFinancialYear.financialYearEndDate).getTime()
    ) {
      props.showMessage(
        "warning",
        translate(
          "Book entry date must be less than or equal new financial year's end date"
        )
      );
      return false;
    }
    return true;
  }

  const content = (
    <Grid container style={{ height: "100%" }}>
      <Grid item xs={12} style={{ height: "5%" }}>
        <table width="100%">
          <tbody>
            <tr>
              <Typography variant="body1">
                <b>{translate("Current financial year")}</b>
              </Typography>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("From")}</Typography>
              </td>
              <td width="30%" style={{ marginRight: 30 }}>
                <Typography variant="body1">
                  {currFinancialYearStartDate}
                </Typography>
              </td>
              <td width="5%" />
              <td>
                <Typography variant="body1">{translate("To")}</Typography>
              </td>
              <td width="30%">{currFinancialYearEndDate}</td>
            </tr>
            <tr>
              <Typography variant="body1">
                <b>{translate("New Financial Year")}</b>
              </Typography>
            </tr>
            <tr>
              <td>
                <Typography variant="body1">{translate("From")}</Typography>
              </td>
              <td width="30%" style={{ marginRight: 30 }}>
                {nextFinancialYearStartDate}
              </td>
              <td width="5%" />
              <td>
                <Typography variant="body1">{translate("To")}</Typography>
              </td>
              <td width="30%">{nextFinancialYearEndDate}</td>
            </tr>
            {showCloseAccount && (
              <tr>
                <Typography variant="body1">
                  <b>{translate("Book Entries")}</b>
                </Typography>
              </tr>
            )}
            {showCloseAccount && (
              <tr>
                <td>
                  <Typography variant="body1">{translate("From")}</Typography>
                </td>
                <td>
                  <PDatePicker
                    value={bookEntryStartDate}
                    InputProps={{ readOnly: true }}
                    onChange={(e) => {
                      let d = new Date();
                      e.$d.setHours(0);
                      e.$d.setMinutes(0);
                      e.$d.setSeconds(0);
                      setBookEntryStartDate(e.$d.toISOString());
                    }}
                  ></PDatePicker>
                </td>
                <td />
              </tr>
            )}
            {!showCloseAccount && (
              <tr>
                <td colspan="2">
                  <Typography variant="body1" color="red">
                    {translate(
                      "You can not close active finacial year now! please wait for the year end"
                    )}
                  </Typography>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {showCloseAccount && (
          <div>
            {loading && (
              <div>
                Progress {progress} - {strProgress}
              </div>
            )}
            {
              <Button onClick={onSave} variant="contained" disabled={loading}>
                {loading && <CircularProgress size={20} />}
                Close accounts and start new fincancial year
              </Button>
            }
          </div>
        )}
      </Grid>
    </Grid>
  );

  const customTitle = (
    <div>
      <table width="100%">
        <tbody>
          <tr>
            <td>{translate("Account Closing")}</td>
          </tr>
        </tbody>
      </table>
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
  return <PCard avatar="A" title={customTitle} content={content}></PCard>;
}
